import React from 'react';
import CarDamageContainer from '../workdoc/CarDamageContainer';
import {Button} from 'react-bootstrap'

export default class CarDamageDebug extends React.Component {
    constructor(props) {
        super(props);

        this.state = {show:false}
    }

    render(){
        const {show} = this.state
        return (<div>
            <Button onClick={()=>{this.setState({show:!this.state.show})}}>show/hide</Button>
            <CarDamageContainer wo={this.props.wo}/>  
            {
                show?(<CarDamageContainer wo={this.props.wo}/>):('')
            }          
            
        </div>)
    }
}




// WEBPACK FOOTER //
// ./src/view/debug/CarDamageDebug.js